import { CSSObject } from "@emotion/react";

import { NAVBAR_BREAKPOINTS } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";

export const expandedSearchBarVisibilityCss: CSSObject = {
  position: "relative",
  marginLeft: "0.5rem",

  [`@media (max-width: ${NAVBAR_BREAKPOINTS.sm}px)`]: {
    display: "none",
  },
};
